import { Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import React, { Fragment, useState, useCallback, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { tableColumns } from "../../Data/DataTable/AdminUser";
import AddAdminUser from "./AddAdminUser";
import axios from "axios";
import { ServerPath } from "../../Constant";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import FilterDropdown from "../../Common/FilterDropdown";
import cookieUtils from "../../utils/cookieUtils";
import greenEye from "../../assets/images/svg/eyegreen.svg";
import DetailInfoAdmin from "./DetailInfoAdmin";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

const DataTablesContain = () => {
  const [users, setUsers] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      const role = cookieUtils.getSecureCookie("role");
      console.log("User role from cookie:", role);
      try {
        const response = await axios.get(`${ServerPath}/web-users`);

        // Validate response structure
        if (!response?.data?.success || !Array.isArray(response?.data?.data)) {
          throw new Error("Invalid data format received from server");
        }

        const actualData = response.data.data;

        // Apply filters based on numeric status values
        let filteredData;
        switch (filterStatus) {
          case "active":
            filteredData = actualData.filter((user) => user.status === 1);
            break;
          case "inactive":
            filteredData = actualData.filter((user) => user.status === 0);
            break;
          case "both":
            filteredData = actualData.filter(
              (user) => user.status === 1 || user.status === 0
            );
            break;
          case "all":
          default:
            filteredData = actualData;
        }

        // Tooltip component
        const renderTooltip = (props) => (
          <Tooltip
            className="custom-tooltip"
            {...props}
            // style={{
            //   backgroundColor: "#000",
            //   color: "#fff",
            //   // border: "none",
            //   // borderRadius: 0,
            //   // boxShadow: "none",
            // }}
          >
            Deactivate
          </Tooltip>
        );

        // Transform the data
        const userData = filteredData
          .map((user) => {
            try {
              return {
                ...user,
                user_image: user.user_image ? (
                  <img
                    src={user.user_image}
                    alt="User"
                    width="45"
                    height="45"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "default-avatar.png"; // Replace with your default image path
                    }}
                  />
                ) : null,
                dateofbirth: user.dateofbirth
                  ? formatDate(user.dateofbirth)
                  : "N/A",
                lastModifiedOn: user.last_modified_on
                  ? formatDate(user.last_modified_on)
                  : "N/A",
                status: user.status === 1 ? "Active" : "Inactive",
                action: (
                  <div className="action d-flex justify-content-center">
                    {role !== "admin" && (
                      <>
                        <div
                          className="edit"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalCenter"
                        >
                          <AddAdminUser data={user} isEditButton={true} />
                        </div>
                        <div className="delete">
                          <OverlayTrigger
                            placement="top" // You can change this to "bottom", "left", or "right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}
                          >
                            <Button
                              onClick={(e) => handleDeleteID(user.user_id, e)}
                              className="btn-square btn btn-danger mx-2"
                            >
                              <i className="icon-na"></i>
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </>
                    )}
                    {role === "admin" && (
                      <div className="view">
                        {/* <DetailInfoAdmin data={user}  /> */}

                        <div
                          className="edit"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalCenter"
                        >
                          {/* <AddAdminUser data={user} isEditButton={true} /> */}
                          <DetailInfoAdmin data={user} isEditButton={true} />
                        </div>
                        {/* <Button
                        onClick={(e) => handleViewID(user.user_id, e)}
                        className="btn-square btn btn-primary mx-2 bg-transparent border-0"
                      >
                        <img src={greenEye} alt="View" width="35" height="30" />
                      </Button> */}
                      </div>
                    )}
                  </div>
                ),
              };
            } catch (err) {
              console.error("Error processing user data:", err, user);
              return null;
            }
          })
          .filter(Boolean); // Remove any null entries from mapping errors

        setUsers(userData.reverse());
      } catch (error) {
        console.error("Error fetching users:", error);
        setError(error.message);
        Swal.fire({
          title: "Error!",
          text: "Failed to load users. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filterStatus]);

  const handleViewID = (userId, event) => {
    event.preventDefault();
    // Handle view functionality
  };

  const handleFilterChange = (status) => {
    console.log("Filter status changed to:", status);
    setFilterStatus(status);
  };

  const handleDeleteID = async (userId, event) => {
    event.preventDefault();
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, deactivate it!",
        cancelButtonText: "No, cancel!",
        customClass: {
          container: "swal2-container",
        },
      });

      if (result.isConfirmed) {
        const response = await axios.get(
          `${ServerPath}/web-users/deactivate/${userId}`
        );

        if (response.data.success) {
          setUsers((prevUsers) =>
            prevUsers.filter((user) => user.user_id !== userId)
          );
          Swal.fire("Deactivated!", "User has been deactivated.", "success");
        } else {
          throw new Error(response.data.message || "Deactivation failed");
        }
      }
    } catch (error) {
      console.error("Error deactivating user:", error);
      Swal.fire(
        "Error!",
        "Failed to deactivate user. Please try again.",
        "error"
      );
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDeactivate = async () => {
    try {
      const result = await Swal.fire({
        title: "Confirm Deactivation",
        text: `Are you sure you want to deactivate ${selectedRows.length} selected users?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, deactivate!",
      });

      if (result.isConfirmed) {
        const promises = selectedRows.map((item) =>
          axios.get(`${ServerPath}/web-users/deactivate/${item.user_id}`)
        );

        await Promise.all(promises);

        setUsers((prevUsers) =>
          prevUsers.filter(
            (user) =>
              !selectedRows.some(
                (selected) => selected.user_id === user.user_id
              )
          )
        );

        setSelectedRows([]);
        setToggleDelet(!toggleDelet);

        Swal.fire(
          "Deactivated!",
          "Selected users have been deactivated.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error in bulk deactivation:", error);
      Swal.fire(
        "Error!",
        "Failed to deactivate some users. Please try again.",
        "error"
      );
    }
  };

  const formatDate = (dateString) => {
    try {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid Date";
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const role = cookieUtils.getSecureCookie("role");

  return (
    <Fragment>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-6">
          <Breadcrumbs
            mainTitle="Web App User Lists"
            parent="Tables"
            title="User List"
          />
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <div className="d-flex justify-content-end align-items-center">
            <FilterDropdown onFilterChange={handleFilterChange} />

            {role !== "admin" && <AddAdminUser isAddUser={true} />}
          </div>
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="pt-0">
                {selectedRows.length > 0 && (
                  <div className="d-flex align-items-center justify-content-between bg-light-info p-2">
                    <H4 attrH4={{ className: "text-muted m-0" }}>
                      Deactivate Selected Users?
                    </H4>
                    <Btn
                      attrBtn={{
                        color: "danger",
                        onClick: handleDeactivate,
                      }}
                    >
                      Deactivate
                    </Btn>
                  </div>
                )}
                <DataTable
                  className="data-tables theme-scrollbar pt-4"
                  data={users}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                  noDataComponent={
                    <div className="p-4">
                      {error ? "Error loading data" : "No users found"}
                    </div>
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DataTablesContain;
